import template from './sw-cms-el-top-finder-selectboxes.html.twig';
import './sw-cms-el-top-finder-selectboxes.scss';

export default {
    template,

    props: {
        element: {
            type: Object,
            required: true,
        },
    },

    computed: {
        displayValue() {
            const mode = this.element.config.selectboxesMode.value || 'both';
            const labels = {
                series: 'Brands \u2192 Series \u2192 Devices',
                types: 'Brands \u2192 Types \u2192 Devices',
                both: 'Brands \u2192 Types/Series \u2192 Devices',
                devices: 'Brands \u2192 Devices',
            };
            return labels[mode] || 'TopFinder Selectboxes';
        },
    },
};
